// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2DqPK","colMin":"styles_colMin__M7IaW","colCheckbox":"styles_colCheckbox__3yyLo"};